import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon, LockIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const basisFeatures = ['6 Kernmodule Industrieautomation — 480 Seiten', '4 professionelle Toolkits — 200 Seiten', '10 Prüfungsmodelle mit vollständigen Lösungen', '50 Praxis-Worksheets & Ladder-Vorlagen', 'Industrielle Schaltplan-Bibliothek', 'Bewertungsraster und Planungsvorlagen', 'Sofort-Download (PDF) 🇨🇭', '100% Industrie 4.0 Konform CH 2026'];
const expertFeatures = ['100 Reale Schweizer Industriefallstudien — 80 Seiten', '25 Fälle: SPS-Programmierung & Fehlerdiagnose', '25 Fälle: Sensorik & Messtechnik CH-Industrie', '25 Fälle: Pneumatische Anlagen Troubleshooting', '25 Fälle: Industrie 4.0 Projekte mit HMI & SCADA', 'Jeder Fall: Sachverhalt + Fragen + Musterlösung', 'Sofort-Download (PDF) 🇨🇭', 'Lebenslange Updates inklusive'];
export function PricingCard() {
  return <section id="pricing" className="py-10 px-4 bg-white scroll-mt-10 border-t border-gray-200" data-id="element-130">
      <div className="max-w-2xl mx-auto" data-id="element-131">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-2xl sm:text-3xl font-black text-center text-brand-charcoal mb-6 sm:mb-8" data-id="element-132">
          Wählen Sie Ihr System.
        </motion.h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 sm:gap-6" data-id="element-133">
          {/* OPTION 1: BASIS */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-brand-card-bg border border-gray-200 rounded-2xl p-5 sm:p-6 flex flex-col" data-id="element-134">
            <h3 className="text-lg sm:text-xl font-black text-brand-charcoal mb-3 flex items-center gap-2" data-id="element-135">
              <span data-id="element-136">📦</span> OPTION 1: BASIS-SYSTEM
            </h3>

            <div className="space-y-2 sm:space-y-2.5 mb-5 flex-grow" data-id="element-137">
              {basisFeatures.map((item, i) => <div key={i} className="flex items-start gap-2" data-id="element-138">
                  <CheckCircle2Icon className="w-4 h-4 sm:w-5 sm:h-5 text-brand-green-cta shrink-0 mt-0.5" data-id="element-139" />
                  <span className="text-[13px] sm:text-sm text-gray-700" data-id="element-140">
                    {item}
                  </span>
                </div>)}
            </div>

            <div className="text-center mb-5" data-id="element-141">
              <div className="text-3xl font-black text-brand-charcoal" data-id="element-142">
                CHF 19.90
              </div>
              <div className="text-[11px] text-gray-500 font-medium mt-0.5" data-id="element-143">
                Einmalzahlung · Kein Abo
              </div>
            </div>

            <CTAButton href="https://suiza.kitonline.shop/cart/44591708110983:1" className="mb-3" data-id="element-144">
              📥 JETZT KAUFEN
            </CTAButton>

            <div className="flex flex-wrap justify-center items-center gap-x-1.5 gap-y-1 text-[10px] sm:text-xs text-gray-500 font-medium" data-id="element-145">
              <span className="flex items-center gap-1" data-id="element-146">
                <LockIcon className="w-3 h-3" data-id="element-147" /> Sichere Zahlung
              </span>
              <span data-id="element-148">·</span>
              <span data-id="element-149">7-Tage-Garantie</span>
              <span data-id="element-150">·</span>
              <span data-id="element-151">Sofort-Zugang</span>
            </div>
          </motion.div>

          {/* OPTION 2: EXPERTEN */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white rounded-2xl p-5 sm:p-6 flex flex-col relative shadow-xl mt-6 sm:mt-0" style={{
          borderTop: '3px solid #F39C12',
          borderLeft: '3px solid #F39C12',
          borderRight: '3px solid #F39C12',
          borderBottom: '1px solid #E5E7EB'
        }} data-id="element-152">
            <div className="absolute -top-3.5 left-1/2 -translate-x-1/2 bg-brand-gold text-white text-[11px] sm:text-xs font-black px-3 py-1 rounded-full uppercase tracking-wide shadow-md whitespace-nowrap" data-id="element-153">
              ⭐ MEISTGEWÄHLT
            </div>

            <h3 className="text-lg sm:text-xl font-black text-brand-charcoal mb-1 flex items-center gap-2 mt-2" data-id="element-154">
              <span data-id="element-155">🏆</span> OPTION 2: EXPERTEN
            </h3>
            <div className="text-[11px] sm:text-xs font-bold text-brand-swiss-red mb-3 uppercase tracking-wide" data-id="element-156">
              + 100 Reale Industriefallstudien
            </div>

            <div className="space-y-2 sm:space-y-2.5 mb-5 flex-grow" data-id="element-157">
              <div className="flex items-start gap-2 font-bold text-brand-charcoal pb-1 border-b border-gray-100" data-id="element-158">
                <CheckCircle2Icon className="w-4 h-4 sm:w-5 sm:h-5 text-brand-gold shrink-0 mt-0.5" data-id="element-159" />
                <span className="text-[13px] sm:text-sm" data-id="element-160">
                  Alles aus dem Basis-System +
                </span>
              </div>
              {expertFeatures.map((item, i) => <div key={i} className="flex items-start gap-2" data-id="element-161">
                  <CheckCircle2Icon className="w-4 h-4 sm:w-5 sm:h-5 text-brand-gold shrink-0 mt-0.5" data-id="element-162" />
                  <span className="text-[13px] sm:text-sm text-gray-700" data-id="element-163">
                    {item}
                  </span>
                </div>)}
            </div>

            <div className="text-center mb-5" data-id="element-164">
              <div className="text-3xl font-black text-brand-charcoal" data-id="element-165">
                CHF 23.90
              </div>
              <div className="text-[11px] text-gray-500 font-medium mt-0.5" data-id="element-166">
                Nur CHF 4.00 mehr als Basis
              </div>
            </div>

            <CTAButton href="https://suiza.kitonline.shop/cart/44591709028487:1" className="mb-3" data-id="element-167">
              ✅ EXPERTEN-SYSTEM KAUFEN
            </CTAButton>

            <div className="flex flex-wrap justify-center items-center gap-x-1.5 gap-y-1 text-[10px] sm:text-xs text-gray-500 font-medium" data-id="element-168">
              <span className="flex items-center gap-1" data-id="element-169">
                <LockIcon className="w-3 h-3" data-id="element-170" /> Sichere Zahlung
              </span>
              <span data-id="element-171">·</span>
              <span data-id="element-172">7-Tage-Garantie</span>
              <span data-id="element-173">·</span>
              <span data-id="element-174">PDF</span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}